//конфиг шаблона компонента
const config = require('./config.yaml');
//базовый класс компонента
const CNoteFrames = require('../../index.js');
const text = require('./text.yaml')[templateVars.lang];

/**
 * Класс CNoteFrames_pageSummaryPreview, наследник CNoteFrames
 * Реализует логику варианта base компонента CNoteFrames
 */
class CNoteFrames_pageSummaryPreview extends CNoteFrames {
	constructor() {
		super();

		this.$noteFrames = $('[data-note-frame-type="page-summary"]');
		//конфиг шаблона компонента
		this.config = config;
	}

	/**
	 * Инициализация компонента
	 */
	init() {
		if (this.$noteFrames.length) {
			// Создать триггеры для фреймов
			this.createFramesTriggers(this.$noteFrames);
		}
	}

	/**
	 * Создать note-frames
	 * @param {object} $triggers элемент
	 */
	createFramesTriggers($triggers) {
		$.each($triggers, (i, trigger) => {
			const $trigger = $(trigger);

			AR
				.components
				.cTooltips_base
				.createTooltips($trigger, {
					content: text.loadingText,
					theme: this.config.theme,
					delayTouch: 100,
					maxWidth: $trigger.attr('data-note-frame-max-width') || 300,
					side: $trigger.attr('data-note-frame-side') || config.side,
					updateAnimation: null,
					functionBefore: (instance, helper) => {
						const $origin = $(helper.origin);
						const url = $origin.attr('data-note-frame-url');
						const customImage = $origin.attr('data-note-frame-image');
						const customTitle = $origin.attr('data-note-frame-title');
						const customDescription = $origin.attr('data-note-frame-description');
						const term = $origin.attr('data-note-frame-term');
						const contentAreaSelector = $origin.attr('data-note-frame-content-area-selector');

						const isExternalUrl = Boolean(url.match(/(http:\/\/)|(https:\/\/)/));
						let data = {
							url: url,
							term: term,
							type: 'page-summary-preview',
							siteUrl: `${templateVars.siteUrl.protocol}://${templateVars.siteUrl.host}`
						};
						let headers = {
							'note-frame-request': true
						};

						if (contentAreaSelector) {
							data.contentAreaSelector = contentAreaSelector;
						}

						$.ajax({
							url: config.parserUrl,
							type: 'post',
							dataType: 'json',
							data: data,
							headers: headers,
							onBefore: () => {
								AR.events.emit('onNoteFramesBeforeSendAjax', $origin, data, headers);
							}
						})
							.done((data, textStatus, jqXHR) => {
								if (data.html) {
									instance.content(data.html);
								} else if (data.fields) {
									const fields = data.fields;
									const title = customTitle || fields.title;
									const image = customImage || fields.image;
									const description = customDescription || fields.description;

									let html = `<div class="b-note-frame-content"><div class="b-note-frame-content__inner">`;

									if (image) {
										html = html + `<div class="b-note-frame-content__image"><div><img src="${image}" alt="${title}"></div></div>`;
										html = html + `<div class="b-note-frame-content__content"><div>
											<h4>${title}</h4>
											<p>${description}</p>
											<div class="b-link-icon b-link-icon--right">
												<div class="b-link-icon__text">
													<a href="${url}" target="_blank">${text.goToSourceLink}</a>
												</div>
												<div class="b-link-icon__icon">
													<i class="webfont-icon webfont-icon--arrow-right2"></i>
												</div>
											</div>
										</div></div>`;
									} else {
										html = html + `<div class="b-note-frame-content__content"><div>
											<h4>${title}</h4>
											<p>${description}</p>
											<div class="b-link-icon b-link-icon--right">
												<div class="b-link-icon__text">
													<a href="${url}" target="_blank">${text.goToSourceLink}</a>
												</div>
												<div class="b-link-icon__icon">
													<i class="webfont-icon webfont-icon--arrow-right2"></i>
												</div>
											</div>
										</div></div>`;
									}


									html = html + `</div></div>`;

									instance.content(html);
								} else {
									instance.content(text.errorLoading);
								}

								AR.events.emit('onNoteFramesDataReady', data, instance, helper);
								$origin.data('loaded', true);
							})
							.fail((jqXHR, textStatus, errorThrown) => {
								AR.events.emit('onNoteFramesDataFail', jqXHR, data, instance, helper);
								if (jqXHR.responseText) {
									const res = $.parseJSON(jqXHR.responseText);
									if (res.error) {
										console.error(`[${jqXHR.status}]: ${jqXHR.statusText} (${res.error})`);
									}
								}

							// call the 'content' method to update the content of our tooltip with the returned data.
							// note: this content update will trigger an update animation (see the updateAnimation option)
								instance.content(text.errorLoading);
							});
					}
				}, false);
		});
	}
}

AR.waitComponents(['cTooltips_base'], () => {
	const cNoteFrames_pageSummaryPreview = new CNoteFrames_pageSummaryPreview();
	// Вызов метода со всеми событиями
	cNoteFrames_pageSummaryPreview.init();
	// Добавление в глобальный объект AR.components
	AR.pushComponent(cNoteFrames_pageSummaryPreview, 'cNoteFrames_pageSummaryPreview');
});



// WEBPACK FOOTER //
// ./temp/components/note-frames/.variant/page-summary-preview/index.js